export default "__VITE_ASSET__9e5e86a6__"